__turbopack_context__.v({
  "background": "nZzg-q_background",
  "background-container": "nZzg-q_background-container",
  "container": "nZzg-q_container",
  "footer": "nZzg-q_footer",
  "image-container": "nZzg-q_image-container",
  "middle-img": "nZzg-q_middle-img",
  "outro": "nZzg-q_outro",
  "subtitle": "nZzg-q_subtitle",
  "terms": "nZzg-q_terms",
  "title": "nZzg-q_title",
});
